module.exports = __webpack_public_path__ + "static/FelipeArcesub-a2636a79b6eb7af2853cc1aa4a7af3de.mp4";